// test488
(488 && 0);
